<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="title">
        搜索
      </div>
      <div class="content">
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
  }
</script>

<style lang="less" scoped>
.search{
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    overflow: hidden;
    width: 9.2rem;
    height: 7.3333333rem;
    box-sizing: border-box;
    position: relative;
    background-image: -webkit-linear-gradient(#000026,#000026),-webkit-linear-gradient(44deg,#ea2278,#1d5eec,#46e5fb);
    background-image: -o-linear-gradient(#000026,#000026),-o-linear-gradient(44deg,#ea2278,#1d5eec,#46e5fb);
    background-image: linear-gradient(#000026,#000026),linear-gradient(46deg,#ea2278,#1d5eec,#46e5fb);
    border: solid 1px transparent;
    background-clip: content-box,border-box;
    background-origin: border-box;
    border-radius: .6666667rem 0;
    &::before{
      position: absolute;
      top:0;
      right: 0;
      content: " ";
      width: 7.2rem;
      height: .2133333rem;
      background: url('@/assets/bulebusiness/before.6c22437e.png');
      background-size: 100%;
    }
    &::after{
      position: absolute;
      bottom:0;
      left: 0;
      content: " ";
      width: 7.2rem;
      height: .2133333rem;
      background: url('@/assets/bulebusiness/after.bc422b53.png');
      background-size: 100%;
    }
    .title{
      margin: 1.0666667rem 0;
      color: #fff;
      text-align: center;
      position: relative;
      font-size: .3733rem;
      z-index: 2;
        &::before{
        position: absolute;
        top:-.3rem;
        right: 34%;
        content: " ";
        width: .6533333rem;
        height: .3466667rem;
        background: url('@/assets/bulebusiness/icon1.png');
        background-size: 100%;
      }
      &::after{
        position: absolute;
        bottom:0;
        left: 0;
        right: 0;
        margin: auto;
        content: " ";
        width: 2rem;
        height: .2133333rem;
        background: -webkit-gradient(linear,left top,right top,from(#ea2278),color-stop(#1d5eec),to(#46e5fb));
        background: -webkit-linear-gradient(left,#ea2278,#1d5eec,#46e5fb);
        background: -o-linear-gradient(left,#ea2278,#1d5eec,#46e5fb);
        background: linear-gradient(90deg,#ea2278,#1d5eec,#46e5fb);
        opacity: .8;
        z-index: -1;
      }
    }
    .content{
      width: 96%;
      margin: auto ;
      .input{
        margin: .8rem 0 .8rem;
        .van-search{
          height: 1.0666667rem;
          background: transparent;
          border: 0.02rem solid #46e5fb;
          padding: 0;
          margin: 0 .2666667rem;
          .van-search__content{
            background: transparent;
          }
          /deep/.van-field__control{
            color: #fff !important;
          }
        }
      }
      .searchBtn{
        height: .96rem;
        margin: 0 .2666667rem;
        box-sizing: border-box;
        .van-button{
          width: 100%;
          height: 100%;
          background: -webkit-gradient(linear,left top,right top,from(#ea2278),color-stop(#1d5eec),to(#46e5fb));
          background: -webkit-linear-gradient(left,#ea2278,#1d5eec,#46e5fb);
          background: -o-linear-gradient(left,#ea2278,#1d5eec,#46e5fb);
          background: linear-gradient(90deg,#ea2278,#1d5eec,#46e5fb);
          border: none;
          border-radius: .5rem;
        }
      }
    }
  }
  div.close{
    margin-top: .5333333rem;
    .van-icon-close{
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>